import styled from "styled-components";
import { Modal, Progress } from "antd";
import { PoolTable, NavigationBtnContainer } from '../../styles';
import { GhostBackButton } from "../../../../../../CommonComponents/CTA/Buttons";
import { ContainerDiv, RiskLabel } from "../../../../../../CommonComponents/ClipDivison/styles";
import { PagePrimaryNumber, SectionSpacing, DataHeading, DataValue } from '../../../../../../CommonComponents/commonStyles';

export const DollarWrapper = styled.div`
> div {
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.textColor};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
}
@media only screen and (max-width: 991px) {
  padding-bottom: 30px;
  border-bottom: solid 1px ${props => props.theme.border.pill};
  ${PagePrimaryNumber}{
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: 20px;
    color: ${props => props.theme.fontColors.textColor};
  }
}
`;

export const CustomSectionSpacing = styled(SectionSpacing)`
  @media only screen and (max-width: 991px) {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
`;

export const Table = styled(PoolTable)`
  &&& {
    //margin-top: 3rem;
    .ant-table .ant-table-thead {
      font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    }
    .ant-table .ant-table-header colgroup col:first-child,
    .ant-table .ant-table-body colgroup col:first-child {
      display: none;
    }
    .ant-table-thead > tr:first-child > th:first-child {
      display: none;
    }
    border-bottom: solid 1px #bfbfbf;
  }
  .ant-table .ant-table-tbody .ant-table-row{    
    td.pool-category-name {
      font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
      font-size: ${props => props.theme.fontSize.h4};
      letter-spacing: ${props => props.theme.letterSpacing.point7};
      color: ${props => props.theme.fontColors.headingColor};
      padding: 30px 10px;
      @media only screen and (max-width: 767px) {
        font-size: 20px;
        width: 100%;
        padding: 10px 0px 20px;
      }
    }
  }
  .ant-table-row:nth-child(2n) {
    background-color: ${props =>
    props.theme.backgroundColor.tableAltRowDark}!important;
  }
  .ant-table-footer {
    background-color: #fff;
    border-bottom: solid 1px #9b9b9b;
    height: 80px;
    align-items: center;
    > div {
      width: 100%;
    }
    @media only screen and (max-width: 767px) {
      height: auto;
    }
  }
`;


export const ToNavigationBtnContainer = styled(NavigationBtnContainer)``;

export const ToTableFooter = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.heading};
  letter-spacing: ${props => props.theme.letterSpacing.point6};
  & > div:nth-child(1) {
    flex-grow: 0.75;
  }
  & > div:nth-child(2) {
    flex-grow: 0.25;
  }
`;

export const PoolName = styled.p`
font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
cursor:pointer
text-decoration: underline;
color:#006778;
`;

export const Input = styled.input`
  border: solid 1px #bfbfbf;
  width: 127px;
  height: 3.125rem;
  padding: 0px 10px;
  @media only screen and (max-width: 991px) {
    width: 130px;
  }
  @media only screen and (min-width: 320px) and (max-width: 374px) {
    width: 100%;
  }
  @media only screen and (min-width: 992px) and (max-width: 1030px) {
    width: 90px;
  }
  ${props => {
    return (
      (props.disabled === true) &&
      `background-color:${props.theme.backgroundColor.tableInputDisabled};
          border: none;
    `
    );
  }}
`;

export const TextTotal = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.textColor};
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.11;
  letter-spacing: 0.6px;
  padding-top: 3px;
`;

export const ClearButton = styled.div`
  padding-left: 430px;
  @media only screen and (max-width: 991.92px) {
    padding-left: 0px;
  }
`;

export const TotalPercent = styled.div`
  flex-grow: 0 !important;
`;

export const TotalSpan = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  background-color: #fff;
  font-size: 14px;
  line-height: 20px;
`;

export const TotalFixedText = styled.p`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.theme.fontColors.textColor};
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: 0.6px;
  font-size: 12px;
`;

export const ErrorMessage = styled.p`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  color: red;
`;

export const ButtonWrapper = styled.div`
  @media only screen and (max-width: 991px) {
    margin-top: 39px;
    width: 100%;
  }
`;

export const GhostBackButtonComponent = styled(GhostBackButton)`
  > div > span {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: 18px;
    font-style: normal;
    font-stretch: condensed;
    line-height: 1.67;
    letter-spacing: 1.1px;
  }
`;

export const ResetAll = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  color: ${props => props.theme.fontColors.primary};
  letter-spacing: ${props => props.theme.letterSpacing.point6};
  font-size: ${props => props.theme.fontSize.primary};
  text-decoration: underline;
  flex-grow:0!important;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: 0.6px;
  cursor: pointer;
`;


export const DescriptionPara = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: ${props => props.theme.fontColors.textColor};
  margin: 0;
  padding-bottom: 29px;
  text-align: left;
`;
export const TableData = styled.p`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: 14px;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.71;
  letter-spacing: normal;
  text-align: left;
  line-height: 24px;
  margin: 0;
  // padding-bottom: 7px;
  color: ${props => props.theme.fontColors.headingColor};
  @media (max-width: 576px) {
    line-height: 21px;
    font-size: 14px;
  }
`;
export const TableRow = styled.div`
  display: flex;
  ${({ justifyContent }) =>
    justifyContent &&
    `
  justify-content: space-between;
  `}
  ${({ margin }) =>
    margin &&
    `
    margin: 15px 0 40px;
  `}
  @media only screen and (max-width: 991.92px) {
    flex-direction: column;
  }
`;
export const ColWrapper = styled.div`
  font-size: 30px;
  text-align: center;
  color: ${props => props.theme.fontColors.headingColor};
  @media only screen and (max-width: 991.92px) {
    margin: 0 12px; 
  }
`;
export const SpacedRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${({ smallWidth }) =>
    smallWidth &&
    `
    width: 143px;
  `}
  ${({ largeWidth }) =>
    largeWidth &&
    `
    width: 207px;
  `}
  ${({ smJustifyStart }) => smJustifyStart && `
    @media only screen and (max-width: 991.92px) {
      justify-content: flex-start;
    }
  `}  
`;
export const Hr = styled.hr`
  margin: 20px 0 0 0;
  height: 50px;
  @media only screen and (max-width: 991.92px) {
    display: none;
  }
`;
export const ContentPara = styled.p`
  margin: 0;
  text-align: left;
  font-size: 14px;
  >span {
    padding-right: 7px;
  }
  ${({ lightText }) =>
    lightText &&
    `
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-weight: normal;
    color: ${props => props.theme.fontColors.textColor};
  `}
  ${({ boldText }) =>
    boldText &&
    `
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-weight: normal;    
    color: ${props => props.theme.fontColors.headingColor};
  `}
  ${({ smallWidth }) =>
    smallWidth &&
    `
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-weight: normal;
    color: ${props => props.theme.fontColors.textColor};
    width: 165px; 
    @media only screen and (max-width: 991.92px) {
      width: 100%; 
    }
`}
${({ longWidth }) =>
    longWidth &&
    `
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-weight: normal;
    color: ${props => props.theme.fontColors.textColor};
    width: 515px; 
    @media only screen and (max-width: 991.92px) {
      width: 100%; 
    }
`}
@media (max-width: 576px) {
  line-height: 21px;
  font-size: 14px;
}

`;
export const Ahref = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: 16px;
  line-height: 1.5;
  > a { color: ${props => props.theme.fontColors.primary} !important; }
  text-decoration: underline;
  margin-left: 10px;
  &:hover {
    text-decoration: underline;
    color: ${props => props.theme.fontColors.primary};
  }
  @media only screen and (max-width: 576px) {
    font-size: 14px;
    line-height: 1.25;
  }
`;
export const TableCol = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 1.5rem;
  margin-bottom: 1.2rem;
  position: relative;
  text-align: left;
  ${({ colWidth }) =>
    colWidth &&
    ` 
    width:${colWidth}       
`}
  &:before{
    position: absolute;
    content:'';
    top: 0;
    bottom: 0;
    margin: auto;
    left: 0;
    width: 1px;
    height: 90%;
    background: rgba(151, 151, 151, 0.46);
  }
  &:first-child{
    padding: 0 1.5rem 0 0;
    &:before{
      display: none;
    }
  }
  &:last-child{
    padding: 0 0 0 1.5rem;
  }
  @media only screen and (max-width: 991.92px) {
    padding: 0 !important;
    width: 100%;
    &:before{
      display: none;
    }
    margin-bottom: 30px;
  }
`;

export const TableModal = styled(Modal)`
  &.ant-modal{
    max-width: 90%;
    @media only screen and (max-width: 991.92px) {    
      max-width: calc(100% - 44px);
      margin: 0 22px;      
      ${ContainerDiv}{
        margin: 0 15px;
      }
      ${RiskLabel}{
        margin: 6px 0;
      }
    }
    @media only screen and (max-width: 767px) {  {
      top: 20px; 
    }
  }
  .ant-modal-title {
    font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
    font-size: ${props => props.theme.fontSize.h4};
    color: ${props => props.theme.fontColors.headingColor};
    text-align: center;
    line-height: 1.17;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    @media(max-width: 576px){
      font-size: ${props => props.theme.fontSize.h5};
    }
  }
  .ant-modal-content {
    border-radius: 0px;
  }
  .ant-modal-header {
    padding: 30px 0 15px 0;
    border: none;
    border-radius: 0;
    @media only screen and (max-width: 991.92px) {
      padding: 30px 0 15px 0;
    }
  }

  .ant-modal-body {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    color: #505050;
    padding: 0 48px 0 33px;
    text-align: center;
    @media only screen and (max-width: 991.92px) {
      max-height: 377px;
      overflow: scroll;
      border-top: 1px solid ${props => props.theme.border.pill};
      border-bottom: 1px solid ${props => props.theme.border.pill};
      padding: 19px 15px 0px 0px;
      margin: 0 20px;
      &:after {
        background: linear-gradient(
            center bottom,
            #fff 0%,
            rgba(255, 255, 255, 0) 60%
          )
          repeat scroll 0 0 rgba(0, 0, 0, 0);
        bottom: 0;
        content: "";
        display: block;
        height: 30px;
        left: 0;
        pointer-events: none;
        position: fixed;
        width: 100%;
      }
    }
  }

  .ant-modal-footer {
    border-radius: 0;
    border: none;
    padding: 0px 0px 30px 0px;
    @media only screen and (max-width: 991.92px) {
      padding: 30px 0px;
    }
  }

  .ant-modal-footer > div {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
  }

  .ant-modal-footer > div > .ant-btn-primary {
    display: none;
  }

  .ant-modal-footer > div > .ant-btn-primary > span {
    color: #fff;
  }

  .ant-modal-footer > div > .ant-btn:first-child {
    border-radius: 0;
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size:${props => props.theme.fontSize.primary};
    line-height: 1.67;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    width: 150px;
    height: 50px;
    color: ${props => props.theme.fontColors.primary};
    border: 1px solid ${props => props.theme.fontColors.primary};
    &:hover {
      border: 1px solid ${props => props.theme.fontColors.primary};
    }
    @media (max-width: 576px) {
      line-height: 21px;
      font-size: 14px;
      padding: 10px 0;
    }
  }

  .ant-modal-footer > div > .ant-btn:first-child > span {
    color: ${props => props.theme.fontColors.color};
  }
`;


/** target allocation **/
export const ProgressUpdated = styled(Progress)`
  &&& {
    .ant-progress-circle-trail {
      stroke: #f0ab00 !important;
    }
  }
`;

export const ProgressLabel = styled(DataHeading)`
  margin-top: -3px;
  margin-left: 9px;
  @media (max-width: 576px) {
    margin-top: -5px;
  }
`;

export const ProgressValue = styled(DataValue)`
  @media (max-width: 576px) {
    margin-top: -3px;
  }
`;

export const ProgressCircle = styled.div`
  margin: 5px 18px 24px 0px;
`;

export const ProgressLabelContainer = styled.div`
  margin-top: 12px;
  @media (max-width: 576px) {
    margin-left: 18px;
  }
`;

export const CashSquare = styled.div`
  width: 10px;
  height: 10px;
  background-color: #0098db;
  margin-right: 8px;
  @media (min-width: 786px){
    margin-top: 5px;
  }
`;

export const StockSquare = styled.div`
  width: 10px;
  height: 10px;
  background-color: #f0ab00;
  margin-right: 8px;
  @media (min-width: 786px){
    margin-top: 5px;
  }
`;